var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.93335,
    y: 0.632812,
    width: 18.4333,
    height: 18.4333,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18.4333,
    height: 18.4333,
    transform: "translate(0.93335 0.632812)",
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7584 6.04669L13.952 5.24023L10.1501 9.04211L6.34821 5.24023L5.54175 6.04669L9.34362 9.84857L5.54175 13.6504L6.34821 14.4569L10.1501 10.655L13.952 14.4569L14.7584 13.6504L10.9565 9.84857L14.7584 6.04669Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.83d72fb618b1205d10673295b1e5f9bb.svg";
export { ForwardRef as ReactComponent };